import classNames from 'classnames';
import Image from 'next/image';
import { forwardRef } from 'react';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { ImageShape, VideoShape } from '@/shared/lib/types';
import Typografed from '../../shared/Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        title?: string | null;
        elements?: { name: string; position: string; theme?: string; above_text?: string; image?: ImageShape }[] | null;
    };
};

const ConstructorPeople = forwardRef<HTMLDivElement, Props>(({ properties: { title, elements }, ...props }, ref) => {
    return (
        <div ref={ref} {...props} className={classNames('constructor-block constructor-people', props.className)}>
            {title && (
                <div className="constructor-people-title text-m">
                    <Typografed>{title}</Typografed>
                </div>
            )}
            <div className="constructor-people-list">
                {elements?.map((element, i) =>
                    element.image ? (
                        <div className="constructor-people-list-image-item" key={i}>
                            <Image
                                className="constructor-people-image"
                                src={element.image.src}
                                alt={element.image.alt || ''}
                                width={element.image.width}
                                height={element.image.height}
                                sizes="(max-width: 768px) 150px, 200px"
                            />
                            <div className="constructor-people-text">
                                {element.above_text && (
                                    <div className="constructor-people-above text-xs">
                                        <Typografed>{element.above_text}</Typografed>
                                    </div>
                                )}
                                {element.name && (
                                    <div className="constructor-people-name text-s">
                                        <Typografed>{element.name}</Typografed>
                                    </div>
                                )}
                                {element.position && (
                                    <div className="constructor-people-position text-xs">
                                        <Typografed>{element.position}</Typografed>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="constructor-people-list-item" key={i}>
                            {element.name && (
                                <div className="constructor-people-name text-s">
                                    <Typografed>{element.name}</Typografed>
                                </div>
                            )}
                            {element.position && (
                                <div className="constructor-people-position text-xs">
                                    <Typografed>{element.position}</Typografed>
                                </div>
                            )}
                            {element.theme && (
                                <div className="constructor-people-theme text-xs">
                                    <Typografed>{element.theme}</Typografed>
                                </div>
                            )}
                        </div>
                    ),
                )}
            </div>
        </div>
    );
});

ConstructorPeople.displayName = 'ConstructorPeople';

export default ConstructorPeople;
